import { render, staticRenderFns } from "./AddOrEditGroupDialog.vue?vue&type=template&id=a1cb7600&scoped=true&"
import script from "./AddOrEditGroupDialog.vue?vue&type=script&lang=js&"
export * from "./AddOrEditGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditGroupDialog.vue?vue&type=style&index=0&id=a1cb7600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cb7600",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VForm,VIcon,VTextField})
